import * as PIXI from "pixi.js";
import { Dictionary } from "../../util/collection/Dictionary";
import { Logger } from "../../util/log/Logger";
/**
 * LocationManager.ts
 */
export class LocationManager {
    constructor() {
        if (LocationManager.instance) {
            throw new Error("SpineCache Singleton Already Initialised");
        }
        this.create();
        LocationManager.instance = this;
    }
    create() {
        this.refStore = new Dictionary();
        Logger.addObjectRef(this, "LocationManager");
    }
    add(key, ref) {
        if (this.refStore.containsKey(key)) {
            throw new Error("LocationManager - Attempt to add duplicate reference key: \"" + key + "\"");
        }
        this.refStore.setValue(key, ref);
    }
    remove(key) {
        this.refStore.remove(key);
    }
    getLocation(key) {
        const ref = this.refStore.getValue(key);
        if (ref instanceof PIXI.Container) {
            let td = ref;
            if (td.getTrackingData) {
                return td.getTrackingData();
            }
        }
        return null;
    }
    static getInstance() {
        if (LocationManager.instance === null) {
            LocationManager.instance = new LocationManager();
        }
        return LocationManager.instance;
    }
}
LocationManager.instance = null;
//# sourceMappingURL=LocationManager.js.map